export const SmartWatch: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.298"
      height="40.2"
      viewBox="0 0 22.298 40.2"
      {...props}
    >
      <g transform="translate(-87.9 -644.9)">
        <g transform="translate(89.572 645)">
          <path
            d="M522.139,3209.627a.69.69,0,0,1-.474-.187c-1.935-1.809-2.934-7-3.194-8.542a.835.835,0,0,0-.827-.7h-8.661a.837.837,0,0,0-.827.7c-.273,1.6-1.308,6.926-3.17,8.532a.694.694,0,0,1-.906-1.051c1.12-.966,2.189-4.676,2.709-7.715a2.221,2.221,0,0,1,2.194-1.852h8.661a2.218,2.218,0,0,1,2.195,1.856c.513,3.05,1.569,6.632,2.773,7.758a.694.694,0,0,1-.474,1.2Z"
            transform="translate(-503.841 -3198.812)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.2"
          />
        </g>
        <g transform="translate(89.533 674.185)">
          <path
            d="M517.292,3504.16h-8.66a2.22,2.22,0,0,1-2.2-1.855c-.513-3.051-1.569-6.634-2.773-7.759a.694.694,0,1,1,.947-1.013c1.935,1.809,2.934,7,3.193,8.542a.837.837,0,0,0,.828.7h8.66a.837.837,0,0,0,.827-.7c.273-1.6,1.308-6.926,3.17-8.532a.694.694,0,1,1,.906,1.051c-1.12.966-2.189,4.676-2.708,7.715A2.221,2.221,0,0,1,517.292,3504.16Z"
            transform="translate(-503.444 -3493.345)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.2"
          />
        </g>
        <g transform="translate(88 653.729)">
          <path
            d="M505.379,3309.442H492.663a4.7,4.7,0,0,1-4.691-4.691V3291.59a4.7,4.7,0,0,1,4.691-4.691h12.716a4.7,4.7,0,0,1,4.691,4.691v13.161A4.7,4.7,0,0,1,505.379,3309.442Zm-12.716-21.156a3.307,3.307,0,0,0-3.3,3.3v13.161a3.307,3.307,0,0,0,3.3,3.3h12.716a3.307,3.307,0,0,0,3.3-3.3V3291.59a3.307,3.307,0,0,0-3.3-3.3Z"
            transform="translate(-487.972 -3286.899)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.2"
          />
        </g>
        <g transform="translate(91.894 657.618)">
          <path
            d="M527.965,3328.919a.694.694,0,0,1-.49-1.184l1.384-1.384a.694.694,0,0,1,.981.981l-1.384,1.384A.691.691,0,0,1,527.965,3328.919Z"
            transform="translate(-527.271 -3326.148)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.2"
          />
        </g>
        <g transform="translate(92.313 658.037)">
          <path
            d="M532.2,3335.594a.694.694,0,0,1-.49-1.184l3.824-3.824a.694.694,0,1,1,.981.981l-3.824,3.824A.693.693,0,0,1,532.2,3335.594Z"
            transform="translate(-531.505 -3330.383)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.2"
          />
        </g>
      </g>
    </svg>
  );
};
